import config from 'config'

export const SubPathLevel = config.APP_SUBPATH
    ? config.APP_SUBPATH.split('/').length - 1
    : 0
